import { Reveal } from "../components/Reveal";
import { Icon } from "../components/Icon";
import { PageHero } from "../components/PageHero";
import { CTA } from "./Home";
import { IMAGES, NDIS_INFO, NDIS_SUPPORTS, CONTACT } from "../data/content";

export default function NDIS() {
  return (
    <div data-testid="ndis-page">
      <PageHero
        testid="ndis-hero"
        eyebrow="NDIS"
        title="Experienced, reassuring NDIS support."
        subtitle="We make navigating the NDIS simple — with clear communication, plan-ready reports, and genuine partnership at every stage."
        image={IMAGES.sunlit}
      />

      {/* How we work with NDIS */}
      <section className="py-12">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <Reveal className="max-w-2xl mb-10"><h2 className="font-display text-3xl sm:text-4xl text-sora-slate leading-snug">How your funding works with us.</h2></Reveal>
          <div className="grid md:grid-cols-2 gap-6">
            {NDIS_INFO.map((n, i) => (
              <Reveal key={n.title} delay={i * 0.08}>
                <div className="rounded-[24px] bg-sora-warm border border-sora-stone/25 p-9 h-full shadow-[0_8px_30px_rgba(63,88,115,0.05)]">
                  <span className="grid place-items-center h-14 w-14 rounded-full bg-sora-blue/12 text-sora-blue"><Icon name={n.icon} size={26} /></span>
                  <h3 className="font-display text-2xl text-sora-slate mt-5">{n.title}</h3>
                  <p className="mt-3 text-sora-charcoal/75 leading-relaxed">{n.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="mt-6 text-sm text-sora-charcoal/60 text-center">
              Please note we are not able to support NDIA-managed (agency-managed) participants at this time. Self and plan managed families — and private paying clients — are warmly welcome. Fees are available on request.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Supports */}
      <section className="py-20 bg-sora-warm/60 mt-8">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <Reveal className="max-w-2xl mb-12"><p className="text-xs uppercase tracking-[0.24em] text-sora-blue font-bold mb-4">What we provide</p><h2 className="font-display text-3xl sm:text-4xl text-sora-slate leading-snug">Everything your child's plan needs.</h2></Reveal>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {NDIS_SUPPORTS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.05}>
                <div className="rounded-[22px] bg-sora-warm border border-sora-stone/25 p-7 h-full">
                  <span className="grid place-items-center h-12 w-12 rounded-full bg-sora-sage/45 text-sora-slate"><Icon name={s.icon} size={22} /></span>
                  <h3 className="font-display text-xl text-sora-slate mt-4">{s.title}</h3>
                  <p className="mt-2 text-sm text-sora-charcoal/75 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Reassurance banner */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <Reveal>
            <h2 className="font-display text-3xl sm:text-4xl text-sora-slate leading-snug">Here to guide you, not overwhelm you.</h2>
            <p className="mt-5 text-lg text-sora-charcoal/75 leading-relaxed">
              If you're unsure where to begin, that's completely okay. Reach out and we'll talk you through your options with patience and care — no jargon, no pressure.
            </p>
            <p className="mt-6 text-sora-slate font-medium">{CONTACT.tagline}</p>
          </Reveal>
        </div>
      </section>

      <CTA />
    </div>
  );
}
